import { useMemo } from "react";
import {
	FaCircleCheck,
	FaCircleExclamation,
	FaCircleInfo,
	FaCircleXmark,
} from "react-icons/fa6";
import { AlertAccent } from "./theme.ts";

const IconProps = { className: "w-[24px] h-[24px] flex-shrink-0" };
const NotifyIcons = {
	[AlertAccent.Danger]: <FaCircleXmark {...IconProps} />,
	[AlertAccent.Warning]: <FaCircleExclamation {...IconProps} />,
	[AlertAccent.Info]: <FaCircleInfo {...IconProps} />,
	[AlertAccent.Success]: <FaCircleCheck {...IconProps} />,
	[AlertAccent.Primary]: <FaCircleInfo {...IconProps} />,
} satisfies Record<AlertAccent, React.ReactNode>;

export default function Notify({
	accent,
	className,
	children,
}: React.PropsWithChildren<{ className?: string; accent: AlertAccent }>) {
	const classes: string[] = ["notify"];
	classes.push(`notify-${accent}`);
	classes.push(className ?? "");
	const icon = useMemo(() => NotifyIcons[accent], [accent]);

	return (
		<aside className={classes.join(" ").trim()}>
			{icon}
			<div>{children}</div>
		</aside>
	);
}
